// extracted by mini-css-extract-plugin
module.exports = {"form":"pages-sponsorships-forms-addQuestionForm__form--3uwPC","buttonsContainer":"pages-sponsorships-forms-addQuestionForm__buttonsContainer--Zc_xc"};